require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-sankt-michael-im-burgenland.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-sankt-michael-im-burgenland");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-sankt-michael-im-burgenland!./.cache/json/betreuungseinrichtungen-guessing-sankt-michael-im-burgenland.json
// module id = 902
// module chunks = 231608221292675